<template>
  <div>
    <section class="otp-verification">
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton"
            ><li>User Profile</li></a
          >
          <li>&nbsp;>&nbsp;Account Management</li>
        </ul>
        <form @submit.prevent>
          <h2>OTP Verification</h2>
          <v-card>
            <p>You will receive an OTP on your registered mobile number.</p>
            <p>Please enter the OTP to confirm permanent account closure.</p>
            <v-text-field
              class="form-group"
              v-model="confirmationCode"
              name="confirmationCode"
              id="confirmationCode"
              placeholder="Enter OTP"
            ></v-text-field>
            <p style="color: red">{{ otpError }}</p>
            <button class="nemia-button active" @click="verifyOtp()">
              VERIFY OTP
            </button>

            <p class="warning-msg">
              In case you don’t receive the OTP in the next 5 minutes, please press Resend button below.
            </p>
            <button class="nemia-button" @click="sendOtp()">RESEND</button>
          </v-card>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PermanentlyCloseAccount",
  data: () => ({
    confirmationCode: "",
    otpError: "",
  }),
  methods: {
    backButton() {
      this.$router.push("/Dashboard");
    },
    sendOtp(){
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append(
        "mobile_no",
        this.$store.getters.getUserDetails.mobile_no
      );
      axios
        .post(
          process.env.VUE_APP_ROOT_API + "send-otp",
          formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          if (this.$store.getters.getVerifyEmailOtp.data.status == 'error') {
            console.log(this.$store.getters.getVerifyEmailOtp)
              return [];
          }else{
            swal.fire({
            title: '',
            text: "OTP sent successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            this.$loading(false);
          })   
          }
        })
        .catch((error)=> {
          this.$loading(false);
        });
    },
    verifyOtp() {
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("otp", this.confirmationCode);
      formdata.append(
        "mobile_no",
        this.$store.getters.getUserDetails.mobile_no
      );
      axios
        .post(
          process.env.VUE_APP_ROOT_API + "verify-otp-delete-account",
          formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data.status == "error") {
            this.otpError = response.data.message;
          } else if (response.data.status == "true") {
            this.otpError = response.data.message;
          } else {
            if (this.$route.query.page == "deletion") {
              this.otpError = "";
              swal
                .fire({
                  html:'<img src="./22.svg"/><h1 style="color:#f19700;">Thank You</h1><br><p>Your account with Nimeya.ai has been permanently closed. You have to sign-up afresh should you wish to start your financial wellness journey with Nimeya.ai in the future.</p><br><p> <b>We thank you for your association with Nimeya.ai.</b></p>',
                  showCancelButton: false,
                  confirmButtonColor: "#051d42",
                  confirmButtonText: "Continue",
                })
                .then((result) => {
                  axios
                    .post(
                      process.env.VUE_APP_ROOT_API + "delete-account",
                      formdata,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.status == "success") {
                        axios
                          .post(
                            process.env.VUE_APP_ROOT_API + "logout",
                            formdata,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            }
                          )
                          .then((response) => {
                            if (response.data.status == "success") {
                              this.$router.push("/");
                            }
                          })
                      }
                    })
                    
                });
            }
            else{
            this.otpError = ''
            swal.fire({
            html:'<img src="./22.svg"/><h1 style="color:#f19700;">Thank You</h1><br><p>Your account has been temporarily deactivated. To activate your account please renew your subscription by paying the subscription fee.</p><br><p> <b>To activate please click below</b></p>',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'Continue',
          }).then((result) => {
            axios.post( process.env.VUE_APP_ROOT_API+'deactivate-account',
            formdata,{
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((response) => {
             if(response.data.status == "success"){
           axios.post( process.env.VUE_APP_ROOT_API+'logout',
            formdata,{
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((response) => {
            console.log(response);
            if(response.data.status == "success"){
               this.$router.push("/");
            }
            })      
                 }
            })
          })   
            }
          }
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>